module.exports = "2"



/*****************
 ** WEBPACK FOOTER
 ** ./~/virtual-dom/vnode/version.js
 ** module id = 87
 ** module chunks = 0
 **/